export enum ToastrMessageType {
	ERROR='ERROR',
	WARNING='WARNING',
	INFO='INFO',
	SUCCESS='SUCCESS'
}
